import React from 'react'
import { Link } from 'gatsby'
import { css } from 'emotion'

export const styles = {}
styles.tagLinkContainer = css`
  color: #080808;
  font-weight: bold;
`;

/**
 * A simple link to tag pages.
 * @param {*} param0
 */
export const TagLink = ({ tag, children }) => (
  <Link to={`/tags/${tag}`} className={styles.tagLinkContainer}>
    {children}
  </Link>
);
